module.exports = __webpack_public_path__ + "media/images/sèche-cheveux-c6efb14707e21f0f3cc6aff1a64cfdb1.svg";